module.exports = __webpack_public_path__ + "img/oie-produkt-01.jpg";